import tw from 'tailwind-styled-components'

export const modalContainerClassName = `
    w-[780px!important]
`

export const DoubleModalContainer = tw.div`
    flex
    gap-8
    mb-8
`

export const DoubleModalFormContainer = tw.div`
    flex-1
    flex
    flex-col
    gap-4
    mb-12
`

export const DoubleModalInfoContainer = tw.div`
    flex
    flex-col
    gap-4
`
export const DoubleModalWarningTextContainer = tw.div`
    flex
    flex-col
`
export const DoubleModalWarningText = tw(DoubleModalWarningTextContainer)`
    mx-auto
    mb-4
`

export const ModalAgendaActionButtonContainer = tw.div`
    flex
    justify-between
    items-center
`
